/*
 * @license
 * Copyright© Celligence International, LLC - 2023
 *
 * This software program is protected by copyright laws and is the property of
 * Celligence International, LLC (Celligence). Any unauthorized reproduction,
 * distribution, modification, or public display of this program, without the
 * explicit permission of Celligence is strictly prohibited. If you have gained
 * access to this program without the expressed approval of Celligence report
 * the incident to legal@celligence.com.
 *
 */
import React, { useEffect } from "react";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import HomePage from "./components/HomePage";
import EventHomePage from "./components/EventHomePage";
import UserEventHomePage from "./components/UserEventHomePage";
import WebsitePreview from "./components/WebsitePreview";
import "./App.css";
import { CookieSetting } from "cookiesetting-component";
import { LocationProvider } from "./components/Utils/LocationContext";

function ExternalRedirect({ to }) {
  useEffect(() => { window.location.replace(to); }, [to]);
  return null;
}

function App() {
  
  useEffect(() => {
    window.scrollTo(0, 0); // Scroll to the top on initial load
}, []); // Empty dependency array ensures this runs only once on mount

  return (
    <React.Fragment>
      <LocationProvider>
        <BrowserRouter basename={process.env.REACT_APP_BASENAME} future={{ v7_startTransition: true, v7_relativeSplatPath: true }}>
          <Routes>
            <Route path="/" element={<HomePage />} />
            <Route path="/nahrepr2026" element={<Navigate to="/caribbean-business-rally" replace />} />
            <Route path="/nahrepr2026/" element={<Navigate to="/caribbean-business-rally" replace />} />
            <Route path="/NAHREP-LA" element={<ExternalRedirect to="https://nahrep.memberclicks.net/2026-la-south-bay-power-of-ai-branding" />} />
            <Route path="/NAHREP-LA/" element={<ExternalRedirect to="https://nahrep.memberclicks.net/2026-la-south-bay-power-of-ai-branding" />} />
            <Route path="/:eventName" element={<EventHomePage />} />
            <Route path="/user/:username/:eventName" element={<UserEventHomePage />} />
            <Route path="/preview/:key" element={<WebsitePreview />} />
          </Routes>
          <CookieSetting 
             privacyPolicyLink={process.env.REACT_APP_PRIVACY_POLICY_LINK} 
             configUrl={process.env.REACT_APP_COOKIE_SETTING_JSON}
             analytics={process.env.REACT_APP_ANALYTICS_PATH}
           />
        </BrowserRouter>
      </LocationProvider>
    </React.Fragment>
  )
}

export default App;
